<template>
  <div class="container">
    <base-form/>
  </div>
</template>


<script>
import BaseForm from "./BaseForm.vue";

export default {
  name: "UpdateForm",
  components: {BaseForm}
}
</script>

<style scoped>

</style>